/**
 * @file h5头部的下载app
 */

var dlHtml = [
    '<div class="sys-down-app">',
        '<img class="banner" alt="" />',
        '<a href="javascript:void(0)" class="close js-sys2-down-app-close"></a>',
        '<a href="//a.app.qq.com/o/simple.jsp?pkgname=com.shijiebang.android.shijiebang&sr=a_dashi_push_H5down" class="go-down"></a>',
    '</div>'
].join('');

// ^\/$ 首页
// ^\/powers\/$ 列表页
// ^\/power\/\d+\/$ 准A
// ^\/supers\/$ 列表页
// ^\/super\/\d+\/$ A计划
// ^\/u\d+\/route\/$ 我的行程
// ^\/see\/ 专题页

var showPathReg = /(^\/$)|(^\/powers\/$)|(^\/power\/\d+\/$)|(^\/supers\/$)|(^\/super\/\d+\/$)|(^\/u\d+\/route\/$)|(^\/see\/)/;

// 判断是否行程大师客户端
function isShijiebang () {
    return navigator.userAgent.indexOf('shijiebang') > -1
}

$(function () {
    // 定义了_nobanner = true 时，也不显示(目前用于京东金融App渠道)
    // 不是行程大师客户端 并且是这些页面
    // 有cps推广条时不显示下载提示
    // 同业用户不显示  isClubUser : true
    // 同业分享出去的也不显示 isClubShare : 1
    if (
        !(typeof _srFromCps !== 'undefined' && _srFromCps)
        && !(typeof _nobanner !== 'undefined' && _nobanner)
        && !isShijiebang()
        && !window.isClubUser
        && !window.isClubShare
        && !$('.mod-cps-extend-topbar').length
        && showPathReg.test(location.pathname)) {
        var lastCloseTime = localStorage._downapp_last_close_time;

        if (!lastCloseTime || new Date().getTime() - lastCloseTime > 24 * 60 * 60 * 1000) {
            var $dl = $(dlHtml);

            $('body').on('click','.js-sys2-down-app-close',function(){
                $dl.remove();
                try {
                    localStorage._downapp_last_close_time = new Date().getTime()
                } catch (e) {}
            })

            $.ajax({
                'url': '/prop/banner/img/',
                'type': 'get',
                'dataType':'json',
                'success': function(data){
                    $dl.find('.banner').attr('src',data.data);
                    $('body').prepend($dl);
                }
            });
        }
    }
})




// WEBPACK FOOTER //
// ./src/module/dl-app.js